module.exports = __webpack_public_path__ + "static/img/brees-2008-slide-2.719dc86.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2008-slide-2.jpg
// module id = 2Yd1
// module chunks = 1